import type { ReactNode } from "react";
import { cn } from "./cn";

export function StatCard({
  label,
  value,
  footnote,
  trend,
  accent = false,
  icon,
  className,
}: {
  label: string;
  value: ReactNode;
  footnote?: ReactNode;
  trend?: { value: string; direction: "up" | "down" | "flat" };
  accent?: boolean;
  icon?: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={cn(
        "group relative overflow-hidden rounded-card border border-line bg-surface p-5 shadow-card",
        "transition-shadow duration-200 ease-out-soft hover:shadow-raised",
        className,
      )}
    >
      {accent ? (
        <span
          aria-hidden
          className="absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent via-brand to-transparent opacity-60"
        />
      ) : null}
      <div className="flex items-start justify-between gap-3">
        <p className="text-2xs font-bold tracking-[0.07em] text-ink-4 uppercase">
          {label}
        </p>
        {icon ? <span className="text-ink-4">{icon}</span> : null}
      </div>
      <p
        className={cn(
          "tnum mt-3 font-display text-2xl font-bold tracking-[-0.02em]",
          accent ? "text-success-ink" : "text-ink",
        )}
      >
        {value}
      </p>
      <div className="mt-2 flex items-center gap-2">
        {trend ? (
          <span
            className={cn(
              "text-2xs font-semibold",
              trend.direction === "up"
                ? "text-success-ink"
                : trend.direction === "down"
                  ? "text-danger-ink"
                  : "text-ink-4",
            )}
          >
            {trend.direction === "up" ? "↑" : trend.direction === "down" ? "↓" : "→"}{" "}
            {trend.value}
          </span>
        ) : null}
        {footnote ? <p className="text-xs text-ink-4">{footnote}</p> : null}
      </div>
    </div>
  );
}
